/**
 * Net
 */

class Net {

  static net( dot = '' ) {

    const host = location.hostname ;

    if ( /^dev\./.test( host ) ) {
      return `dev${dot}`;
    } else if ( /^(rc\.|rc-)/.test( host ) ) {
      return `rc${dot}`;
    } else if ( /^(sb\.|sb-)/.test( host ) ) {
      return `sb${dot}`;
    } else if ( /^opdev/.test( host ) ) {
      return `opdev${dot}`;
    }

    return '';
  }

  static isLive() {
    return ( Net.net() === '' ) ? true : false;
  }

  static getStaticUrl() {
    // @TODO this.net()으로 변경
    let serviceEnv = window._serviceEnv || 'live';
    let url = '';

    serviceEnv = serviceEnv.toLowerCase();

    switch ( serviceEnv ) {
    case 'opdev':
      url = 'http://ui-static.korea.ncsoft.corp';
      break;
    case 'sb':
      url = 'https://sb-wstatic.plaync.com';
      break;
    case 'rc':
      url = 'https://rc-wstatic.plaync.co.kr';
      break;
    default:
      url = 'https://wstatic-cdn.plaync.com';
    }

    return url;
  }
}

export default Net;
